export function viewEnabled(data, enabledFilter) {
  let newData = [...data];

  if (
    enabledFilter.includes('enabled') &&
    !enabledFilter.includes('disabled')
  ) {
    newData = data.filter((item) => item.enabled);
  } else if (
    enabledFilter.includes('disabled') &&
    !enabledFilter.includes('enabled')
  ) {
    newData = data.filter((item) => !item.enabled);
  }

  return [...newData];
}
